var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaleConosco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "96.000000pt",
    viewBox: "0 0 100.000000 96.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,96.000000) scale(0.100000,-0.100000)",
    fill: "#a51713",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407 949 c-99 -23 -199 -105 -239 -197 -11 -25 -23 -73 -25 -107 l-5 -60 -47 -15 c-32 -11 -53 -25 -68 -49 -21 -31 -23 -46 -23 -155 0 -187 27 -216 200 -216 l100 0 0 215 0 215 -56 0 -57 0 6 55 c19 180 183 298 369 265 139 -25 233 -125 245 -262 l6 -58 -57 0 -56 0 0 -215 0 -215 66 0 c58 0 65 -2 54 -15 -9 -11 -34 -15 -100 -15 -85 0 -90 1 -118 30 -28 28 -36 30 -102 30 -62 0 -74 -3 -95 -25 -36 -35 -34 -88 4 -126 26 -25 37 -29 86 -29 63 0 110 20 120 50 6 18 15 20 103 20 104 0 153 17 166 58 4 10 22 26 41 35 62 30 75 65 75 203 0 109 -2 124 -23 155 -16 24 -36 38 -70 49 l-47 15 0 47 c0 129 -106 267 -235 307 -70 22 -152 26 -218 10z m-162 -584 l0 -160 -78 0 c-110 0 -117 10 -117 157 0 60 5 118 11 129 15 29 46 38 119 36 l65 -2 0 -160z m684 129 c18 -23 21 -41 21 -125 0 -54 -5 -109 -11 -123 -14 -31 -56 -46 -125 -46 l-54 0 0 160 0 160 74 0 c69 0 76 -2 95 -26z m-365 -360 c19 -18 21 -65 4 -82 -16 -16 -120 -16 -136 0 -17 17 -15 58 5 80 21 23 104 25 127 2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaleConosco);
export default __webpack_public_path__ + "static/media/fale_conosco.5830c6ac566eb4a6cac1ce20ba7807fe.svg";
export { ForwardRef as ReactComponent };